<template>
  <div class="blog-post__footer-socials">
    <a
      v-for="(website, index) in websiteList"
      :key="index"
      :href="generateUrl[website]"
      :aria-label="'share on ' + website"
      @click.prevent="share(website)"
    >
      <i :class="'iconmoon-' + website"></i>
    </a>
    <!--TODO: somehow generate hidden links automaticly too-->
    <span v-show="!collapsed" class="js-collapsed">
      <a
        :href="generateUrl['linkedin']"
        aria-label="share on linkedin"
        @click.prevent="share('linkedin')"
      >
        <i class="iconmoon-linkedin2"></i>
      </a>
      <a
        :href="generateUrl['googlePlus']"
        aria-label="share on google plus"
        style="position: relative; top: 2px"
        @click.prevent="share('googlePlus')"
      >
        <i class="iconmoon-google-plus"></i>
      </a>

      <a :href="generateUrl['email']" class="butn" aria-label="share email">
        <i class="iconmoon-email"></i>
      </a>
    </span>
    <button class="butn js-toggle-collapse" @click="toggleCollapse">
      <i class="iconmoon-dots-three-horizontal"></i>
    </button>
  </div>
</template>

<script>
import generateSharedUrl from "./generateSharedUrl";

export default {
  name: "SharedButtons",
  props: {
    post: Object
  },
  data() {
    return {
      collapsed: true,
      websiteList: ["facebook", "twitter", "vk"]
    };
  },
  computed: {
    generateUrl() {
      const url = window.location.href;
      const title = this.post.title;
      const description = this.post.intro_text_stripped;

      return generateSharedUrl(url, title, description);
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    share(type) {
      window.open(
        this.generateUrl[type],
        null,
        "width=600, height=400, location=0, menubar=0, resizeable=0, scrollbars=0, status=0, titlebar=0, toolbar=0"
      );
    }
  }
};
</script>

<style scoped></style>
